import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  acceptAddressUpdateLoading: false,
  address1: '',
  address2: '',
  addressUpdateError: null,
  areNamesUpdated: false,
  arePhonesUpdated: false,
  cancelingAddressUpdate: false,
  city: '',
  discountData: null,
  endorsementData: null,
  endorsementMessageModalVisible: false,
  endorsementSuccessModalVisible: false,
  errorAddress: '',
  errorUpdateInsuranceInformation: null,
  firstName: '',
  FirstNameHasNumbers: false,
  isAddress1Valid: true,
  isAddress2Valid: true,
  isCityValid: true,
  isConfirmAddressChangeModalVisible: false,
  isFirstNameValid: true,
  isLastNameValid: true,
  isMultiplePetsModal: false,
  isNamesBeingUpdated: false,
  isPhonesBeingUpdated: false,
  isPrimaryPhoneValid: true,
  isSecondaryPhoneValid: true,
  isZipCodeValid: true,
  lastName: '',
  LastNameHasNumbers: false,
  loadingUpdateInsuranceInformation: false,
  namesUpdateError: null,
  pets: [],
  petsLoading: false,
  phonesUpdateError: null,
  pictureEditing: {
    error: false,
    loading: false,
    message: '',
    success: false,
  },
  primaryPhone: '',
  PrimaryPhoneHasLetters: false,
  profile: {},
  profileLoading: false,
  secondaryPhone: '',
  SecondaryPhoneHasLetters: false,
  state: null,
  states: [],
  telusLink: '',
  userInfo: {},
  zipCodeHasLetters: false,
};
const NAME_REGEX = /^[a-z ,.'-]+$/i;

export default handleActions({
  AVATAR_PICTURE_REMOVED: (state) => ({
    ...state,
    pictureEditing: {
      ...state.pictureEditing,
      error: false,
      loading: false,
      success: true,
    },
  }),
  CHANGE_PROFILE_PICTURE: (state) => ({
    ...state,
    pictureEditing: {
      ...INITIAL_STATE.pictureEditing,
      loading: true,
    },
  }),
  CHANGE_PROFILE_PICTURE_FAILED: (state, { payload }) => ({
    ...state,
    pictureEditing: {
      ...state.pictureEditing,
      loading: false,
      message: payload,
    },
  }),
  CHANGE_PROFILE_PICTURE_RESTART: (state) => ({
    ...state,
    pictureEditing: {
      ...state.pictureEditing,
      loading: false,
      message: '',
      success: false,
    },
  }),
  CHANGE_PROFILE_PICTURE_SUCCESS: (state) => ({
    ...state,
    pictureEditing: {
      ...state.pictureEditing,
      loading: false,
      success: true,
    },
  }),
  CLEAR_NAMES_UPDATE_ERROR: (state) => ({
    ...state,
    namesUpdateError: null,
  }),
  CONFIRM_ADDRESS_CHANGE_MODAL_CHANGED: (state, { payload }) => ({
    ...state,
    isConfirmAddressChangeModalVisible: payload,
  }),
  COVER_PICTURE_REMOVED: (state) => ({
    ...state,
    pictureEditing: {
      ...state.pictureEditing,
      error: false,
      loading: false,
      success: true,
    },
  }),
  DISCOUNT_DATA_LOADED: (state, { payload }) => ({
    ...state,
    discountData: payload,
  }),
  DO_LOGOUT: () => ({ ...INITIAL_STATE }),
  FIRST_NAME_CHANGED: (state, { payload }) => ({
    ...state,
    areNamesUpdated: false,
    firstName: payload,
    FirstNameHasNumbers: /\d/.test(payload),
    isFirstNameValid: NAME_REGEX.test(payload),
  }),
  LAST_NAME_CHANGED: (state, { payload }) => ({
    ...state,
    areNamesUpdated: false,
    isLastNameValid: NAME_REGEX.test(payload),
    lastName: payload,
    LastNameHasNumbers: /\d/.test(payload),
  }),
  LAST_NAME_RESET: (state) => ({
    ...state,
    isLastNameValid: true,
    lastName: state.userInfo.LastName,
    LastNameHasNumbers: false,
  }),
  NAMES_UPDATED: (state, { payload }) => ({
    ...state,
    areNamesUpdated: true,
    firstName: payload.FirstName,
    isFirstNameValid: true,
    isLastNameValid: true,
    isNamesBeingUpdated: false,
    lastName: payload.LastName,
    namesUpdateError: null,
    userInfo: {
      ...state.userInfo,
      FirstName: payload.FirstName,
      LastName: payload.LastName,
    },
  }),
  PETS_LOAD_ATTEMPT: (state) => ({
    ...state,
    petsLoading: true,
  }),
  PETS_LOADED: (state, { payload }) => ({ ...state, pets: [...payload] }),
  PETS_LOADED_FINISHED: (state) => ({
    ...state,
    petsLoading: false,
  }),
  PHONES_UPDATED: (state) => ({
    ...state,
    arePhonesUpdated: true,
    isPhonesBeingUpdated: false,
    phonesUpdateError: null,
    userInfo: {
      ...state.userInfo,
      OtherPhoneNumber: state.secondaryPhone,
      PhoneNumber: state.primaryPhone,
    },
  }),
  REMOVE_AVATAR_PICTURE: (state) => ({
    ...state,
    pictureEditing: {
      ...state.pictureEditing,
      error: false,
      loading: true,
      success: false,
    },
  }),
  REMOVE_AVATAR_PICTURE_FAILED: (state) => ({
    ...state,
    pictureEditing: {
      ...state.pictureEditing,
      error: true,
      loading: false,
      success: false,
    },
  }),
  REMOVE_COVER_PICTURE: (state) => ({
    ...state,
    pictureEditing: {
      ...state.pictureEditing,
      error: false,
      loading: true,
      success: false,
    },
  }),
  REMOVE_COVER_PICTURE_FAILED: (state) => ({
    ...state,
    pictureEditing: {
      ...state.pictureEditing,
      error: true,
      loading: false,
      success: false,
    },
  }),
  SAVE_USER_INFO: (state, { payload }) => ({
    ...state,
    address1: payload.Address.Line1,
    address2: payload.Address.Line2 || '',
    city: payload.Address.City,
    firstName: payload.FirstName,
    lastName: payload.LastName,
    primaryPhone: payload.PhoneNumber,
    secondaryPhone: payload.OtherPhoneNumber || '',
    state: payload.Address.StateId,
    userInfo: payload,
    zipCode: payload.Address.ZipCode,
  }),
  SAVE_USER_INFO_ADDRESS: (state, { payload }) => ({
    ...state,
    userInfo: {
      ...state.userInfo,
      Address: {
        ...state.userInfo.Address,
        City: payload.city,
        StateId: payload.state,
        ZipCode: payload.zipCode,
      },
    },
  }),
  SOCIAL_PROFILE_LOAD_ATTEMPT: (state) => ({
    ...state,
    profileLoading: true,
  }),
  SOCIAL_PROFILE_LOADED: (state, { payload }) => ({
    ...state,
    profile: payload,
  }),
  SOCIAL_PROFILE_LOADED_FINISHED: (state) => ({
    ...state,
    profileLoading: false,
  }),
  STARTUP_FROM_CACHE: (state, { payload }) => ({
    ...state,
    userInfo: payload.userInfo,
  }),
  STORE_STATES: (state, { payload }) => ({
    ...state,
    states: payload,
  }),
  TELUS_DOCS_LOADED: (state, { payload }) => ({
    ...state,
    telusLink: payload,
  }),
  UPDATE_INSURANCE_INFORMATION: (state) => ({
    ...state,
    loadingUpdateInsuranceInformation: true,
  }),
  UPDATE_INSURANCE_INFORMATION_FAILED: (state) => ({
    ...state,
    errorUpdateInsuranceInformation: true,
    loadingUpdateInsuranceInformation: false,
  }),
  UPDATE_INSURANCE_INFORMATION_SUCCESS: (state) => ({
    ...state,
    errorUpdateInsuranceInformation: false,
    loadingUpdateInsuranceInformation: false,
  }),
  UPDATE_NAMES: (state) => ({
    ...state,
    areNamesUpdated: false,
    isNamesBeingUpdated: true,
  }),
  UPDATE_NAMES_FAILED: (state, { payload }) => ({
    ...state,
    isNamesBeingUpdated: false,
    namesUpdateError: payload,
  }),
}, INITIAL_STATE);
